import { render } from "./PregameScreen.vue?vue&type=template&id=432dcff8"
import script from "./PregameScreen.vue?vue&type=script&lang=js"
export * from "./PregameScreen.vue?vue&type=script&lang=js"
script.render = render

export default script